import {
  Tab as MuiTab,
  makeStyles,
} from '@material-ui/core'
import useStyles from './styles'

export const Tab = ({label, count, noMargin = false, ...props}) => {
  const classes = useStyles()

  const newLabel = count ? `${label} (${count})` : label

  return (
    <MuiTab
      wrapped
      classes={{
        root: noMargin ? classes.tabNoMargin : classes.tab,
        selected: classes.tabSelected,
      }}
      label={newLabel}
      {...props}
      >
    </MuiTab>
  )
}

export default Tab